/* MF — Sélecteur « Club de cœur » (snippets/mf-club-picker.liquid)
   Combobox « select-only » accessible (motif WAI-ARIA APG) :
   ↑ ↓ Début Fin PgPréc PgSuiv, Entrée/Espace pour choisir, Échap pour fermer,
   saisie de lettres pour sauter à un club. Au choix : met à jour le champ caché
   et émet « mf-club-change » (bubbles, detail.value). */
(function () {
  if (window.MFClubPicker) { window.MFClubPicker.init(); return; }

  function norm(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function setup(root) {
    if (root.dataset.mfCpReady) return;
    root.dataset.mfCpReady = '1';

    var btn = root.querySelector('.mf-cp__trigger');
    var list = root.querySelector('.mf-cp__list');
    var input = root.querySelector('input[type="hidden"]');
    var valueEl = root.querySelector('.mf-cp__value');
    if (!btn || !list || !input || !valueEl) return;
    var opts = Array.prototype.slice.call(list.querySelectorAll('[role="option"]'));
    var active = -1;
    var typed = '';
    var typedTimer = null;
    var suppressClick = false;

    function isOpen() { return !list.hidden; }
    function selectedIndex() {
      for (var i = 0; i < opts.length; i++) if (opts[i].getAttribute('aria-selected') === 'true') return i;
      return -1;
    }
    function ensureVisible(o) {
      var top = o.offsetTop, bottom = top + o.offsetHeight;
      if (top < list.scrollTop) list.scrollTop = top;
      else if (bottom > list.scrollTop + list.clientHeight) list.scrollTop = bottom - list.clientHeight;
    }
    function setActive(i) {
      if (i < 0) i = 0;
      if (i > opts.length - 1) i = opts.length - 1;
      if (active > -1 && opts[active]) opts[active].classList.remove('is-active');
      active = i;
      var o = opts[i];
      o.classList.add('is-active');
      btn.setAttribute('aria-activedescendant', o.id);
      ensureVisible(o);
    }
    function open(idx) {
      list.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      root.classList.add('is-open');
      var s = selectedIndex();
      setActive(typeof idx === 'number' ? idx : (s > -1 ? s : 0));
    }
    function close(refocus) {
      list.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      btn.removeAttribute('aria-activedescendant');
      root.classList.remove('is-open');
      if (active > -1 && opts[active]) opts[active].classList.remove('is-active');
      active = -1;
      if (refocus) btn.focus();
    }
    function choose(i) {
      var o = opts[i];
      if (!o) return;
      opts.forEach(function (x) { x.setAttribute('aria-selected', 'false'); });
      o.setAttribute('aria-selected', 'true');
      input.value = o.getAttribute('data-value');
      valueEl.innerHTML = '';
      var media = o.querySelector('img, .mf-cp__pict');
      if (media) {
        var m = media.cloneNode(true);
        if (m.tagName === 'IMG') m.removeAttribute('loading');
        valueEl.appendChild(m);
      }
      var label = document.createElement('span');
      label.className = 'mf-cp__label';
      label.textContent = input.value;
      valueEl.appendChild(label);
      root.classList.add('has-value');
      close(true);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      root.dispatchEvent(new CustomEvent('mf-club-change', { bubbles: true, detail: { value: input.value } }));
    }
    function typeahead(ch) {
      clearTimeout(typedTimer);
      typedTimer = setTimeout(function () { typed = ''; }, 700);
      typed += norm(ch);
      var n = opts.length;
      var start = active < 0 ? -1 : active;
      // même lettre répétée (« s », « ss ») : club suivant qui commence par cette lettre
      var same = typed.split('').every(function (c) { return c === typed[0]; });
      var q = same ? typed[0] : typed;
      var offset = same ? 1 : 0;
      for (var t = 0; t < n; t++) {
        var idx = ((start + offset + t) % n + n) % n;
        if (norm(opts[idx].getAttribute('data-value')).indexOf(q) === 0) { setActive(idx); return; }
      }
    }

    btn.addEventListener('click', function () {
      if (suppressClick) { suppressClick = false; return; }
      if (isOpen()) close(false); else open();
    });

    btn.addEventListener('keydown', function (e) {
      var k = e.key;
      if (e.altKey && (k === 'ArrowDown' || k === 'ArrowUp')) {
        e.preventDefault();
        if (isOpen()) { if (k === 'ArrowUp') choose(active); } else open();
        return;
      }
      if (!isOpen()) {
        if (k === 'ArrowDown' || k === 'ArrowUp' || k === 'Enter' || k === ' ') {
          e.preventDefault(); suppressClick = true; open(); return;
        }
        if (k === 'Home') { e.preventDefault(); open(0); return; }
        if (k === 'End') { e.preventDefault(); open(opts.length - 1); return; }
        if (k.length === 1 && !e.ctrlKey && !e.metaKey) {
          open();
          if (selectedIndex() < 0) { opts[active].classList.remove('is-active'); active = -1; }
          typeahead(k);
        }
        return;
      }
      switch (k) {
        case 'ArrowDown': e.preventDefault(); setActive(active + 1); break;
        case 'ArrowUp': e.preventDefault(); setActive(active - 1); break;
        case 'Home': e.preventDefault(); setActive(0); break;
        case 'End': e.preventDefault(); setActive(opts.length - 1); break;
        case 'PageDown': e.preventDefault(); setActive(active + 10); break;
        case 'PageUp': e.preventDefault(); setActive(active - 10); break;
        case 'Enter':
          e.preventDefault(); suppressClick = true; choose(active); break;
        case ' ':
          e.preventDefault(); suppressClick = true;
          if (typed) typeahead(' '); else choose(active);
          break;
        case 'Escape': e.preventDefault(); e.stopPropagation(); close(true); break;
        case 'Tab': close(false); break;
        default:
          if (k.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) typeahead(k);
      }
    });
    btn.addEventListener('keyup', function (e) {
      if (e.key === ' ' || e.key === 'Enter') setTimeout(function () { suppressClick = false; }, 0);
    });

    // garder le focus sur le bouton pendant le clic dans la liste
    list.addEventListener('mousedown', function (e) { e.preventDefault(); });
    opts.forEach(function (o, i) {
      o.addEventListener('click', function () { choose(i); });
      o.addEventListener('mousemove', function () { if (active !== i) setActive(i); });
    });

    document.addEventListener('pointerdown', function (e) {
      if (isOpen() && !root.contains(e.target)) close(false);
    });
    root.addEventListener('focusout', function (e) {
      if (isOpen() && e.relatedTarget && !root.contains(e.relatedTarget)) close(false);
    });
  }

  window.MFClubPicker = {
    init: function (scope) {
      (scope || document).querySelectorAll('[data-mf-club-picker]').forEach(setup);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { window.MFClubPicker.init(); });
  } else {
    window.MFClubPicker.init();
  }
})();
